export const REGEX_SCIENTIFIC_NOTATION = new RegExp(/^[+-]?[0-9]*\.[0-9]+([eE][+-]?[0-9]+)?$/);
export const REGEX_NUMERIC_AND_LENGTH = new RegExp(/^\d{12,13}$/);
